import { siteInfo } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center overflow-hidden bg-background-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20mysterious%20dramatic%20stage%20with%20intense%20red%20spotlight%20beam%20cutting%20through%20darkness%2C%20abstract%20geometric%20shapes%20in%20shadows%2C%20cinematic%20atmosphere%2C%20no%20people%2C%20artistic%20composition%20with%20deep%20blacks%20and%20warm%20crimson%20highlights%2C%20editorial%20photography&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
          alt="每日大赛黑料 赛事内幕 背景主题"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-28 md:py-32">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-400 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>今日已更新 37 条爆料</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display text-background-50 leading-tight">
              {siteInfo.siteName}
              <span className="block text-primary-400 mt-2 text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                {siteInfo.tagline}
              </span>
            </h1>

            <p className="mt-2 text-lg md:text-xl text-primary-300/80 font-display tracking-wider">
              {siteInfo.slogan}
            </p>

            <p className="mt-6 text-sm md:text-base text-background-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {siteInfo.description}
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-2xl md:text-3xl font-display text-accent-400">{stat.value}</p>
                  <p className="text-xs text-background-400 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href={siteInfo.ctaPrimary.href}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                {siteInfo.ctaPrimary.text}
              </a>
              <a
                href={siteInfo.ctaSecondary.href}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-background-300/30 text-background-200 font-semibold text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                {siteInfo.ctaSecondary.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=dramatic%20artistic%20composition%20of%20a%20mysterious%20spotlight%20on%20a%20dark%20stage%20with%20floating%20newspaper%20fragments%20and%20red%20warning%20tape%2C%20conceptual%20art%20about%20exposing%20secrets%2C%20dark%20atmosphere%20with%20crimson%20accents%2C%20editorial%20photography%20style%2C%20no%20people&width=800&height=900&seq=hero-visual-2026&orientation=portrait"
                alt="每日大赛黑料 独家爆料 赛事内幕揭秘"
                className="relative w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}